import cn from 'classnames'

import type { ResizeDirection } from '../useFieldDrag'
import type { SimulatorField } from './InputField'
import * as s from './InputResizerHandlers.module.scss'

const OFFSET = -3

interface IInputResizerHandlersProps {
  selected: boolean
  field: SimulatorField
  onResize: (
    e: React.MouseEvent<HTMLDivElement>,
    field: SimulatorField,
    direction: ResizeDirection,
  ) => void
}

const handlers: { style: React.CSSProperties; direction: ResizeDirection }[] = [
  { style: { left: OFFSET, top: OFFSET, cursor: 'nwse-resize' }, direction: 'top-left' },
  { style: { right: OFFSET, top: OFFSET, cursor: 'nesw-resize' }, direction: 'top-right' },
  { style: { left: OFFSET, bottom: OFFSET, cursor: 'nesw-resize' }, direction: 'bottom-left' },
  { style: { right: OFFSET, bottom: OFFSET, cursor: 'nwse-resize' }, direction: 'bottom-right' },
]

const InputResizerHandlers = ({ selected, field, onResize }: IInputResizerHandlersProps) => {
  return handlers.map((handler, index) => (
    <div
      className={cn(s.root, { [s.visible]: selected })}
      key={index}
      onMouseDown={(e) => onResize(e, field, handler.direction)}
      style={handler.style}
    />
  ))
}

export default InputResizerHandlers
